(ns renolit-roofing-service.entity-list
  (:require [clojure.string :as str]
            [dev.gethop.session.re-frame.cognito.token :as cognito.token]
            [medley.core :as medley]
            [re-frame.core :as rf]
            [renolit-roofing-service.localization :as localization]
            [renolit-roofing-service.util :as util]))

(def ^:const load-entity-list-data-loading-id "load-entity-list")
(def ^:const load-filter-options-data-loading-id "load-filter-options")

(rf/reg-event-db
 ::clean-entity-data
 (fn [db [_ entity-key]]
   (dissoc db entity-key)))

;; List
(rf/reg-sub
 ::list
 (fn [db [_ entity-key]]
   (get-in db [entity-key :list])))

(rf/reg-event-db
 ::set-list
 (fn [db [_ entity-key list]]
   (assoc-in db [entity-key :list] list)))

(rf/reg-event-db
 ::append-list
 (fn [db [_ entity-key list]]
   (update-in db [entity-key :list]
              #(->> (concat % list)
                    (medley/distinct-by :id)))))

;; Filters
(rf/reg-sub
 ::filters
 (fn [db [_ entity-key]]
   (get-in db [entity-key :filters :selected])))

(rf/reg-sub
 ::filter-options
 (fn [db [_ entity-key]]
   (get-in db [entity-key :filters :options])))

(rf/reg-sub
 ::filters-selected+options
 (fn [db [_ entity-key]]
   {:selected (get-in db [entity-key :filters :selected])
    :options (get-in db [entity-key :filters :options])}))

(rf/reg-event-db
 ::set-filters-selected+options
 (fn [db [_ entity-key filters-selected+options]]
   (assoc-in db [entity-key :filters] filters-selected+options)))

(rf/reg-event-db
 ::set-filter-options
 (fn [db [_ entity-key filter-id filter-options]]
   (assoc-in db [entity-key :filters :options filter-id] filter-options)))

(rf/reg-event-db
 ::set-all-filter-options
 (fn [db [_ entity-key filter-options]]
   (assoc-in db [entity-key :filters :options] filter-options)))

(rf/reg-event-db
 ::remove-filter-option
 (fn [db [_ entity-key filter-id option-id]]
   (update-in db [entity-key :filters :options filter-id] dissoc option-id)))

(rf/reg-event-db
 ::set-filters
 (fn [db [_ entity-key filters]]
   (assoc-in db [entity-key :filters :selected] filters)))

(rf/reg-event-db
 ::set-filter
 (fn [db [_ entity-key filter-key filter-value]]
   (if filter-value
     (assoc-in db [entity-key :filters :selected filter-key] filter-value)
     (update-in db [entity-key :filters :selected] dissoc filter-key))))

;; Pagination
(rf/reg-sub
 ::pagination
 (fn [db [_ entity-key]]
   (get-in db [entity-key :pagination])))

(rf/reg-event-db
 ::set-pagination
 (fn [db [_ entity-key pagination]]
   (assoc-in db [entity-key :pagination] pagination)))

(rf/reg-sub
 ::selected-items
 (fn [db [_ entity-key]]
   (get-in db [entity-key :selected-items])))

(rf/reg-sub
 ::selected-item
 (fn [db [_ entity-key path]]
   (let [item-id (last path)
         items-list-path (vec (butlast path))
         selected-items (get-in db (vec (concat [entity-key] items-list-path)))]
     (contains? (set selected-items) item-id))))

(rf/reg-sub
 ::all-items-selected?
 (fn [db [_ entity-key path]]
   (get-in db (vec (concat [entity-key] path)))))

(rf/reg-event-db
 ::set-selected-items
 (fn [db [_ entity-key selected-items]]
   (assoc-in db [entity-key :selected-items] selected-items)))

(rf/reg-event-db
 ::set-all-selected-items
 (fn [db [_ entity-key value]]
   (assoc-in db [entity-key :all-items-selected?] value)))

(rf/reg-event-db
 ::update-pagination
 (fn [db [_ entity-key pagination]]
   (update-in db [entity-key :pagination] merge pagination)))

;; Sorting
(rf/reg-sub
 ::sorting
 (fn [db [_ entity-key]]
   (get-in db [entity-key :sort-by])))

(rf/reg-event-db
 ::set-sorting
 (fn [db [_ entity-key sorting]]
   (assoc-in db [entity-key :sort-by] sorting)))

;; Obtain entity list from BE
(rf/reg-event-fx
 ::list-load-success
 (fn [_ [_ {:keys [on-success-evt entity-key keep-prv-data?]} response]]
   {:fx (cond-> []
          keep-prv-data?
          (conj [:dispatch [::append-list entity-key (:list response)]])

          (not keep-prv-data?)
          (conj [:dispatch [::set-list entity-key (:list response)]])

          (:pagination response)
          (conj [:dispatch [::update-pagination entity-key (:pagination response)]])

          on-success-evt
          (conj [:dispatch on-success-evt]))}))

(rf/reg-event-fx
 ::list-load-error
 (fn [_ [_ {:keys [on-failure-evt]} _response]]
   {:fx (cond-> [[:dispatch [::util/generic-error
                             {:data-loading-id load-entity-list-data-loading-id}]]]
          on-failure-evt
          (conj [:dispatch on-failure-evt]))}))

(defn- load-list-event-fx
  [{:keys [db session]} [_ {:keys [entity-key uri extra-params] :as opts}]]
  (let [selected-filters (get-in db [entity-key :filters :selected])
        pagination (get-in db [entity-key :pagination])
        sorting (get-in db [entity-key :sort-by])
        language (localization/get-language db)
        path-param-ks (->> uri
                           (re-seq #":([a-z\-]+)")
                           (map (comp keyword second)))
        query-param-filters (apply dissoc selected-filters path-param-ks)
        parsed-uri (reduce
                    (fn [uri k]
                      (str/replace-first uri (str k) (get selected-filters k)))
                    uri
                    path-param-ks)
        absolute-uri (if (util/absolute-url? parsed-uri)
                       parsed-uri
                       (str (:api-url db) parsed-uri))]
    {:http-xhrio {:headers
                  {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                  :method :get
                  :uri absolute-uri
                  :params (cond-> {}
                            (seq query-param-filters)
                            (assoc :filters query-param-filters)

                            language
                            (assoc-in [:filters :language] language)

                            (seq pagination)
                            (assoc :pagination pagination)

                            (seq sorting)
                            (assoc :sort-by (util/serialize-sort-by-params sorting))

                            (seq extra-params)
                            (medley/deep-merge extra-params))
                  :response-format (util/ajax-transit-response-format)
                  :format (util/ajax-transit-request-format)
                  :on-success [::list-load-success opts]
                  :on-failure [::list-load-error opts]}}))

(rf/reg-event-fx
 ::load-list
 [(rf/inject-cofx ::cognito.token/session)]
 load-list-event-fx)

;; Filter options
(rf/reg-event-fx
 ::filter-options-load-success
 (fn [_ [_ entity-key filter-id response]]
   {:fx [[:dispatch [::set-filter-options entity-key filter-id (:list response)]]]}))

(rf/reg-event-fx
 ::load-filter-options
 [(rf/inject-cofx ::cognito.token/session)]
 (fn [{:keys [db session]} [_ entity-key entity-list-opts filter-id filter-value]]
   (let [language (localization/get-language db)
         uri (get-in entity-list-opts [:load-data :uri])
         extra-params (get-in entity-list-opts [:load-data :extra-params])
         absolute-uri (if (util/absolute-url? uri)
                        uri
                        (str (:api-url db) uri))
         params (cond-> {:filters {:ids filter-value}}
                  language
                  (assoc-in [:filters :language] language))]
     {:http-xhrio {:headers
                   {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                   :method :get
                   :uri absolute-uri
                   :params (if extra-params
                             (merge extra-params params)
                             params)
                   :response-format (util/ajax-transit-response-format)
                   :on-success [::filter-options-load-success entity-key filter-id]
                   :on-failure [::util/generic-error
                                {:data-loading-id load-filter-options-data-loading-id}]}})))

(rf/reg-event-fx
 ::ensure-selected-filter-options
 (fn [{:keys [db]} [_ entity-key filters-entity-list-opts]]
   {:fx (reduce
         (fn [evts [filter-id filter-value]]
           (if-let [filter-entity-list-opts (get filters-entity-list-opts filter-id)]
             (let [filter-value (if (coll? filter-value) filter-value [filter-value])
                   filter-options (get-in db [entity-key :filters :options filter-id])]
               (if (every?
                    (fn [value-id]
                      (some #(= value-id (:id %)) filter-options))
                    filter-value)
                 evts
                 (conj
                  evts
                  [:dispatch
                   [::load-filter-options entity-key filter-entity-list-opts filter-id filter-value]])))
             evts))
         []
         (get-in db [entity-key :filters :selected]))}))

(defn count-applied-filters
  [filters]
  (reduce
   (fn [n [_filter-id filter-value]]
     (if (coll? filter-value)
       (+ n (count (keep identity filter-value)))
       (if-not (seq filter-value)
         n
         (inc n))))
   0
   filters))
